// @ts-nocheck
// Every agent on a call right now, pulled straight from the live roster —
// this is the team lead's listen-in list. Columns are limited to what the
// realtime payload actually carries (agent, group, activity, call state);
// there is no live-calls endpoint, so no customer or duration column is
// invented here.
import React from 'react';
import { PhoneCall } from 'lucide-react';
import { Dot, EmptyNote, HAIRLINE, Panel, Pill, TONE, TableShell, Td, Th } from './teamUi';
import SnoopButtons from './SnoopButtons';

export default function TeamOnCallPanel({ agents, snoop, canSnoop, onOpenAgent }) {
  const onCall = agents.filter((a) => a.stateKey === 'onCall');

  return (
    <Panel className="p-3.5">
      {onCall.length > 0 ? (
        <div className="mb-3 flex items-center justify-between gap-2">
          <p className="text-[11px] text-muted-foreground">
            {onCall.length} agent{onCall.length === 1 ? '' : 's'} connected — monitor, whisper or barge in
          </p>
          {snoop.session ? (
            <button type="button" onClick={snoop.stop} disabled={snoop.busy}>
              <Pill tone="crit">{snoop.busy ? 'Stopping…' : `Stop ${snoop.session.mode}`}</Pill>
            </button>
          ) : null}
        </div>
      ) : null}

      {onCall.length === 0 ? (
        <EmptyNote>
          <span className="inline-flex items-center gap-1.5">
            <PhoneCall size={13} />
            No connected calls
          </span>
        </EmptyNote>
      ) : (
        <div className={`overflow-hidden rounded-xl border ${HAIRLINE}`}>
          <TableShell maxH={320}>
            <thead>
              <tr>
                <Th>Agent</Th>
                <Th>Call group</Th>
                <Th>Extension</Th>
                <Th>Activity</Th>
                <Th>Call state</Th>
                <Th align="center">Listen</Th>
              </tr>
            </thead>
            <tbody>
              {onCall.map((row) => (
                <tr key={row.id} className="transition-colors hover:bg-muted/40">
                  <Td>
                    <button
                      type="button"
                      onClick={() => onOpenAgent(row)}
                      className="flex items-center gap-2 text-left"
                    >
                      <Dot tone="call" size={6} />
                      <span className="truncate text-[12px] font-medium">{row.name}</span>
                    </button>
                  </Td>
                  <Td className="text-[11px] text-muted-foreground">{row.groupName || '—'}</Td>
                  <Td className="text-[11px] tabular-nums text-muted-foreground">{row.extension || '—'}</Td>
                  <Td className="text-[11px] text-muted-foreground">{row.activity || '—'}</Td>
                  <Td>
                    <span className={`text-[11px] font-medium ${row.snoop.answered ? TONE.good.text : TONE.warn.text}`}>
                      {row.snoop.answered ? 'Answered' : 'Connecting'}
                    </span>
                  </Td>
                  <Td align="center">
                    <SnoopButtons row={row} snoop={snoop} allowed={canSnoop} />
                  </Td>
                </tr>
              ))}
            </tbody>
          </TableShell>
        </div>
      )}
    </Panel>
  );
}
